import { MatElementsModule } from './../_modules/mat-elements.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';


import { QrFeePaymentRoutingModule } from './qr-fee-payment-routing.module';
import { QrPaylayoutComponent } from './qr-paylayout.component';
import { QrPayStudentComponent } from './qr-pay-student.component';

import { MatIconModule } from '@angular/material/icon';
import { QrCaptureResponseComponent } from './qr-capture-response.component';

@NgModule({

  imports: [
    CommonModule,
    ReactiveFormsModule,
    QrFeePaymentRoutingModule,
    MatElementsModule,
    MatIconModule
  ],
  declarations: [
    QrPaylayoutComponent,
    QrPayStudentComponent,
    QrCaptureResponseComponent
  ]
})
export class QrFeePaymentModule { }
